export enum ApplicationFormSchemaStepType {
  OAUTH = 'oauth',
  FIELDS = 'fields',
  SSO_FIELDS = 'sso_fields',
  CONNECTION_CHECK = 'connection_check',
}
